import React from "react";
import ROUTE_NAMES from "./routeNames";
import PrivateRoute from "./privateRoute";
import MainLayout from "../layout";
import UserDetails from "../views/users/userDetail";
import CMS from "../views/cms";
import Profile from "../views/auth/profile";
import Sites from "../views/sites";
import AddSites from "../views/sites/addSite";
import UpdateSite from "../views/sites/updateSite";
import SideDetail from "../views/sites/siteDetail";
import Cities from "../views/cities";
import CityDetail from "../views/cities/citiDetail";
import CityUpdate from "../views/cities/cityUpdate";
import ReportManager from "../views/reportManager";
import Feedback from "../views/feedback";
import FeedbackDetails from "../views/feedback/FeedbackDetails";
import Queries from "../views/queries";
import QueryDetails from "../views/queries/queryDetails";
import HowToVideos from "../views/howToVideos";
import EmailTemplates from "../views/emails";
import EmailTemplateDetails from "../views/emails/details";
import Articles from "../views/articles";
import AddArticles from "../views/articles/add";
import EditArticle from "../views/articles/edit";
import RatingsAndReviews from "../views/ratingsAndReviews";

/**
 * @function MainRoutes
 * @description for MainRoutes Private Routes
 * @returns JS for MainRoutes
 */

const Dashboard = React.lazy(() => import("../views/dashboard"));
const Users = React.lazy(() => import("../views/users"));

const MainRoutes = {
  path: ROUTE_NAMES.BASE_ROUTE,
  element: (
    <PrivateRoute>
      <MainLayout />
    </PrivateRoute>
  ),
  children: [
    {
      path: ROUTE_NAMES.MAIN_ROUTES.DASHBOARD,
      element: <Dashboard />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.USERS,
      element: <Users />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.USER,
      element: <UserDetails />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CMS,
      element: <CMS />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.PROFILE,
      element: <Profile />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.SITES,
      element: <Sites />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.ADD_SITES,
      element: <AddSites />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.UPDATE_SITE,
      element: <UpdateSite />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.SITES_DETAIL,
      element: <SideDetail />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CITIES,
      element: <Cities />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CITY_DETAIL,
      element: <CityDetail />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CITY_UPDATE,
      element: <CityUpdate />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.REPORT_MANAGEMENT,
      element: <ReportManager />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.FEEDBACK,
      element: <Feedback />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.FEEDBACK_DETAILS,
      element: <FeedbackDetails />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.QUERIES,
      element: <Queries />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.QUERY_DETAILS,
      element: <QueryDetails />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.HOT_TO_VIDEOS,
      element: <HowToVideos />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.EMAILS,
      element: <EmailTemplates />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.EMAILS_DETAILS,
      element: <EmailTemplateDetails />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.ARTICLES,
      element: <Articles />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.ADD_ARTICLES,
      element: <AddArticles />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.VIEW_EDIT_ARTICLES,
      element: <EditArticle />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.RATINGS_AND_REVIEWS,
      element: <RatingsAndReviews />,
    },
  ],
};

export default MainRoutes;
